module.exports = __webpack_public_path__ + "static/img/voice4_down.a1b30c20.png";